import { render, staticRenderFns } from "./page-test-template.vue?vue&type=template&id=289dc6a2&"
import script from "./page-test-template.vue?vue&type=script&lang=js&"
export * from "./page-test-template.vue?vue&type=script&lang=js&"
import style0 from "./page-test-template.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loader: require('/usr/src/app/components/loader/loader.vue').default,ProductHeroTest: require('/usr/src/app/components/product-new/product-hero-test.vue').default,RichText: require('/usr/src/app/components/product-new/rich-text.vue').default,ProductTextImage: require('/usr/src/app/components/product-new/product-text-image.vue').default,OrangeTextBox: require('/usr/src/app/components/product-new/orange-text-box.vue').default,DocTypesPreviewV2: require('/usr/src/app/components/product-new/doc-types-preview-v2.vue').default,StatesTable: require('/usr/src/app/components/product-new/states-table.vue').default,StatesTablePersonalized: require('/usr/src/app/components/product-new/states-table-personalized.vue').default,Checkmarks: require('/usr/src/app/components/product-new/checkmarks.vue').default,Faqs: require('/usr/src/app/components/product-new/faqs.vue').default,InlineReviews: require('/usr/src/app/components/product-new/inline-reviews.vue').default,StepsNew: require('/usr/src/app/components/product-new/steps-new.vue').default,IconDotCheckmark: require('/usr/src/app/components/icons/icon-dot-checkmark.vue').default,LnCustomButton: require('/usr/src/app/components/ln-custom-button.vue').default,FooterCta: require('/usr/src/app/components/common-sections/footer-cta.vue').default})
